var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7071_5556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7071_5556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14C1.08333 14 0.729333 13.854 0.438 13.562C0.146 13.2707 0 12.9167 0 12.5V3.5C0 3.08333 0.146 2.72933 0.438 2.438C0.729333 2.146 1.08333 2 1.5 2H14.5C14.9167 2 15.2707 2.146 15.562 2.438C15.854 2.72933 16 3.08333 16 3.5V12.5C16 12.9167 15.854 13.2707 15.562 13.562C15.2707 13.854 14.9167 14 14.5 14H1.5ZM8 9L1.5 5.271V12.5H14.5V5.271L8 9ZM8 7.229L14.5 3.5H1.5L8 7.229ZM1.5 5.271V3.5V12.5V5.271Z",
    fill: "#384A5F"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4c3393113b882304098bb7811220bbf4.svg";
export { ForwardRef as ReactComponent };